import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { RelationshipSearchResult } from './RelationshipSearchResult';

export class AccountRelationshipSearchResource extends FBaseService {
  public async searchByName(fiId:string, customerName:string,
    customerLimit:number, accountLimit:number) : Promise<RelationshipSearchResult[]> {
    const response:AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/account-relationship-search?customerName=${customerName}`
      + `&customerLimit=${customerLimit}&accountLimit=${accountLimit}`,
    );
    const results:RelationshipSearchResult[] = response.data.data;
    return results;
  }

  public async searchByAccountNumber(fiId:string, accountNumber:string, limit:number)
    : Promise<RelationshipSearchResult[]> {
    const response:AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/account-relationship-search?accountNumber=${accountNumber}&accountLimit=${limit}`,
    );
    const results:RelationshipSearchResult[] = response.data.data;
    return results;
  }
}

export default AccountRelationshipSearchResource;
